// unsubscribeStreamChannel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Unsubscribe stream channel
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const unsubscribeStreamChannel =
  ({ streamId }) =>
  async dispatch => {
    if (!streamId) {
      return dispatch({ type: '' });
    }

    return sendMessageToSW({
      type: MessageTypes.UNSUBSCRIBE_STREAM_CHANNEL,
      payload: {
        streamId,
      },
    });
  };

export default unsubscribeStreamChannel;
